import snakeCaseKeys from 'snakecase-keys'

export default {
  methods: {
    openInNewTab ({ route, external }) {
      window.open(external ? route : this.$router.resolve(route).href, '_blank')
    },

    getUrlEncoded (string) {
      if (decodeURIComponent(string) === string) return encodeURIComponent(string)
      return encodeURIComponent(decodeURIComponent(string))
    },

    buildQueryStringFromObject (obj, { snakeCase } = {}) {
      if (snakeCase) obj = snakeCaseKeys(obj)
 
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'boolean') {
          if (!obj[key]) delete obj[key]
        } else {
          if (!obj[key] || !obj[key].length) {
            delete obj[key]
          }
        }
      })
      return (Object.keys(obj).length ? '?' : '') +
        Object.keys(obj)
          .map(key => {
            return (
              this.getUrlEncoded(key) + '=' + this.getUrlEncoded(obj[key])
            )
          })
          .join('&')
    },
  },
}
